import React from 'react';
import LinkProvider from '../../../CommonComponents/LinkProvider/LinkProvider';
import { isEmptyObject } from '../../../utils/helper';
import './AppDownloadBanner.scss';

const AppDownloadBanner = props => {
  const {
    dataLocale: { DOWNLOAD_APP, EXCLUSIVE_VOUCHER, EXTRA_OFF },
  } = props;
  let ua;
  let osType = '';
  if (typeof window !== 'undefined') {
    ua = window.navigator.userAgent;
    if (/Android/i.test(ua)) {
      osType = 'android';
    } else if (/iPhone/i.test(ua)) {
      osType = 'ios';
    }
  }
  let data = {
    text1: EXTRA_OFF,
    text2: EXCLUSIVE_VOUCHER,
    items: [
      { osType: 'android', img: 'https://static.lenskart.com/images/cust_mailer/5-July/aqua.jpg' },
      {
        osType: 'ios',
        img: 'https://static.lenskart.com/images/cust_mailer/18-Apr/images/sab_04.jpg',
      },
    ],
    url: 'https://lenskart.onelink.me/747387224/d9cff77b?pid=mobile_web_ditto_trip&af_adset=MSITE_PDP',
  };
  if (props.data && !isEmptyObject(props.data)) {
    data = props.data;
  }
  return (
    <div className="download-banner pd-8 bg-color_white">
      {osType.length && (
        <LinkProvider to={data.url}>
          <div className="display-flex align-items-center">
            <div className="download-info display-flex flex-direction-column text-dark_grey_blue">
              <span className="fsp12 dwnld-banner-text1 text-uppercase">
                <strong>{data.text1}</strong>
              </span>
              <span className="fsp8 dwnld-banner-text2 text-uppercase">{data.text2}</span>
            </div>
            {data.items.map((item, index) => {
              return (
                osType === item.osType && (
                  <div
                    key={index}
                    className="download-actions display-flex align-items-center justify-space-around"
                  >
                    <img alt={DOWNLOAD_APP} src={item.img} />
                  </div>
                )
              );
            })}
          </div>
        </LinkProvider>
      )}
    </div>
  );
};

export default AppDownloadBanner;
